import CartSaleWideContainer from './CartSaleWideContainer'

export default CartSaleWideContainer
